import {EventEmitter, Injectable} from '@angular/core';
import {ToastParams} from 'src/app/components_2.1/toast/toast.module';
import {ItemConfig} from 'src/app/models/ItemConfig';

@Injectable({
  providedIn: 'root'
})
export class GlobalEventsService {
  ToastNotificationEvent: EventEmitter<ToastParams> = new EventEmitter<ToastParams>();
  UpdatedObjectEvent: EventEmitter<ItemConfig> = new EventEmitter<ItemConfig>();
  isSomeHintVisible: boolean;
}
